import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

interface ProductSpec {
  label: string;
  value: string;
}

interface CopierProduct {
  id: string;
  slug: string;
  brand: string;
  category: string;
  badge: string;
  title: string;
  type: string;
  image: string;
  sourceUrl: string;
  summary: string;
  features: string[];
  specs: ProductSpec[];
  details: string[];
}

@Component({
  selector: 'app-product-copier-xerox',
  templateUrl: './product-copier-xerox.component.html',
  styleUrls: ['../product-copier-canon/product-copier-canon.component.css']
})
export class ProductCopierXeroxComponent implements OnInit {
  products: CopierProduct[] = [];
  selectedProduct: CopierProduct | null = null;
  loading = true;

  constructor(private http: HttpClient, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.http.get<CopierProduct[]>('assets/data/copier-xerox.json').subscribe(products => {
      this.products = products;
      this.loading = false;
      this.pickProduct(this.route.snapshot.paramMap.get('slug'));
    });

    this.route.paramMap.subscribe(params => {
      if (this.products.length) {
        this.pickProduct(params.get('slug'));
      }
    });
  }

  private pickProduct(slug: string | null): void {
    this.selectedProduct = slug ? this.products.find(product => product.slug === slug) || null : null;
  }
}
